export default "__VITE_ASSET__BYp31YSu__"